module.exports = __webpack_public_path__ + "img/Single-dependant.c3758041.svg";